import React, { useEffect } from 'react';
import Cookies from 'universal-cookie';
import DsConnectedView from '../view/DsConnectedView';
import { useHistory } from 'react-router-dom';
import useFetchWithCallbacks from '../../hooks/useFetchWithCallbacks';

const DsConnectedEngine = () => {
  const cookies = new Cookies();
  const fetchAPI = useFetchWithCallbacks();
  const history = useHistory();
  function getParameterByName(name) {
      var url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
  useEffect(() => {
    let code, errorNumberSpan, errorTextSpan, errorDescriptionDiv, state,tenantId, token;
    try {
      tenantId = cookies.get('tenant');
      code = getParameterByName('code');
      state = JSON.parse(getParameterByName('state'));
      if (!code) {
        code = 'error';
      }

      if (code === 'error') {
        console.warn('Something went wrong.', code);
        return;
      }

      fetchAPI(
        '/scheduler/v1/ds/connect',
        {
          method: 'PUT',
          headers: 
          {
            'Content-Type': 'application/json',        
            'Authorization': cookies.get(`auth-header-${tenantId}`),
            'x-ds-connect-token':`${code}`
          },
          body: {
            assetId: state.formId,
            integrationType: 'docusign'
          }
        }
      ).then(res => {
        let newUrl = `/${tenantId}/form-builder/${state.formId}/integrations?connect=docusign`;
        window.location.href = newUrl;
      }).catch(err => {
        console.warn('Something went wrong.', err);
      });
    } catch (e) {
      console.warn('Something went wrong.', e);
    };
  }, []);

  /*errorNumberSpan = document.getElementById('errorNumber');
  errorTextSpan = document.getElementById('errorText');
  errorDescriptionDiv = document.getElementById('errorDescription');
  errorNumberSpan.innerHTML = 'ERR001';
  errorTextSpan.innerHTML = 'Connected successfully';
  errorDescriptionDiv.innerHTML = 'Connected successfully';*/

  return (
    <DsConnectedView />
  );
};

export default DsConnectedEngine;